import React from "react";
import ReactDOM from "react-dom/client";
import "./Style/index.css";
import App from "./Components/App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import DashboardStore from "Store/DashboardStore";
import * as am5 from "@amcharts/amcharts5";

// ライセンスキー
am5.addLicense("AM5C-511207401081121");

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <React.StrictMode>
    <Provider store={DashboardStore}>
      <App />
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
